module.exports = __webpack_public_path__ + "static/media/Illus-Winter@2x.ac8dbaed.png";